import { Heading, HEADING_LEVELS, HEADING_TYPES } from "@cdkglobal/radial";
import type { HeadingProps } from "@cdkglobal/radial";
import type React from "react";
import styled from "styled-components";

export const FooterContainer = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 20;
  width: 100%;
  background: #fff;
`;

export const FooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.5rem 1rem;
  border: 1px solid #bdc3c7;
  border-radius: 4px;
  background: #fff;
`;

export const FooterLabel = styled(
  Heading as React.ComponentType<HeadingProps>,
).attrs({
  level: HEADING_LEVELS.LEVEL_4,
  type: HEADING_TYPES.SUBTITLE_1,
})`
  margin: 0;
`;

export const FooterDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  padding-left: 1rem;
  border-left: 1px solid #9d9d9d;
`;

export const FooterTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
`;

export const FooterValue = styled(
  Heading as React.ComponentType<HeadingProps>,
).attrs({
  level: HEADING_LEVELS.LEVEL_4,
  type: HEADING_TYPES.SUBTITLE_1,
})<{ $isInvalid?: boolean }>`
  margin: 0;
  color: ${({ $isInvalid }) => ($isInvalid ? "#d32f2f" : "#196fe1")};
`;
